<template>
  <c-row>
    <c-col col="12">
      <loader v-show="loading" />
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Logbook Asset</strong>
            <div class="card-header-actions">
              <date-range @select="changeDate" />
            </div>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div style="overflow: auto">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th rowspan="2" valign="middle">Kode Asset</th>
                  <th rowspan="2">Nama Aset</th>
                  <th rowspan="2">Tanggal</th>
                  <th rowspan="2">Qty</th>
                  <th rowspan="2">Harga</th>
                  <th rowspan="2">Total</th>
                  <th rowspan="2">Duration</th>
                  <th rowspan="2">Beban</th>
                  <th colspan="2" v-for="(y, k) in years" :key="k">{{ y }}</th>
                </tr>
                <tr>
                  <th v-for="(y, k) in years2" :key="k">
                    <span v-show="k % 2 == 0">Depre</span>
                    <span v-show="k % 2 == 1">Sisa</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in assets.data" :key="k">
                  <td>{{ d.code }}</td>
                  <td>{{ d.name }}</td>
                  <td>{{ d.date | dateFormat }}</td>
                  <td class="right">{{ d.qty }}</td>
                  <td class="right">{{ d.price | thousandSeparator }}</td>
                  <td class="right">{{ d.total | thousandSeparator }}</td>
                  <td class="right">{{ d.duration }}</td>
                  <td class="right">{{ d.expense }}%</td>
                  <td class="right" v-for="(y, ky) in years2" :key="ky">
                    <span v-show="ky % 2 == 0">{{
                      d.depreciation[y].depreciation | thousandSeparator
                    }}</span>
                    <span v-show="ky % 2 == 1">{{
                      d.depreciation[y].remaining | thousandSeparator
                    }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <export-excel
            class="float-left"
            :url="`/api/v1/export/excel/asset?${dateRangeS}`"
          />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import ExportExcel from "../../components/ExportExcel.vue";
import Loader from '../../components/Loader.vue';
import DateRange from "../../components/DateRange";
export default {
  name: "LogBookAsset",
  components: {
    ExportExcel,
    Loader,
    DateRange
  },
  data () {
    return {
      loading: true,
      assets: [],
      years: [],
      years2: [],
      filter: {
        date: ''
      },
      dateRange: null,
      dateRangeS: '',
    };
  },
  created () {
    this.getAssets();
  },
  methods: {
    getAssets () {
      this.loading = true;
      var dateRange = "";
      var startDate = "";
      var endDate = "";
      if (this.dateRange) {
        startDate = this.dateRange.startDate.format("YYYY-MM-DD");
        endDate = this.dateRange.endDate.format("YYYY-MM-DD");
        dateRange = `&start_date=${startDate}&end_date=${endDate}`;
      }
      HTTPAUTH.get(`/api/v1/asset?${dateRange}`).then(res => {
        this.assets = res.data;
        const depreciation = this.assets.data[0].depreciation;
        this.setYears(depreciation);
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    setYears (depreciation) {
      for (var i in depreciation) {
        this.years.push(i);
        this.years2.push(i);
        this.years2.push(i);
      }
    },
    changeDate (v) {
      this.dateRange = {
        startDate: moment(v.startDate),
        endDate: moment(v.endDate),
      };
      var startDate = "";
      var endDate = "";
      if (this.dateRange) {
        startDate = this.dateRange.startDate.format("YYYY-MM-DD");
        endDate = this.dateRange.endDate.format("YYYY-MM-DD");
        this.dateRangeS = `&start_date=${startDate}&end_date=${endDate}`;
      }
      this.getAssets()
    },
  }
};
</script>